import { render, staticRenderFns } from "./TipoDeManutencaoCadastro.vue?vue&type=template&id=32d14782"
import script from "./TipoDeManutencaoCadastro.vue?vue&type=script&lang=js"
export * from "./TipoDeManutencaoCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports